export class Channel {
    static channelObj: null|Channel;
    channel: BroadcastChannel;
    static getChannelObj() {
        if (!Channel.channelObj) {
             Channel.channelObj = new Channel();
            }
        return Channel.channelObj;
    }
    constructor() {
        this.channel = new BroadcastChannel('channel');
    }

    postMessage(type: string, value: string|number|object|number[]|object[]|string[]) {

        this.channel.postMessage({type, value});
    }
    subscribeChannel(func: (this: BroadcastChannel, ev: MessageEvent) => any) {
        this.channel.addEventListener('message', func);
    }


}
